module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_013.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_013.png
// module id = 936
// module chunks = 0